import React from 'react';
import {
  Label,
  TextField,
  Text,
  Stack,
  Icon,
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  ChoiceGroup,
  ChoiceGroupOption
} from '@fluentui/react';
import ComboBoxInput from '../../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import InputField from '../../../lib/FormValidator/Form/InputField';
import MessageCourier from '../../../lib/MessageCourier';
import SystemClient from '../../../system/SystemClient';
import RegistroEntrenadorForm from '../../RegistroEntrenador/RegistroEntrenadorForm';
import { useCustomInput } from '../../../common/custom-hooks/useCustomInput';
import useForceUpdate from '../../../common/custom-hooks/useForceUpdate';
import RegistroEntrenadorAntiguedadForm from '../../RegistroEntrenadorAntiguedad/RegistroEntrenadorAntiguedadForm';
import { ClubSelectorInput } from '../../../components/Club/ClubSelector';
import { CategoriaSelectorInput } from '../../../components/Categoria/CategoriaSelector';
import { AppContext } from '../../../AppInRouterContext';
import useAsyncDataCourier from '../../../common/custom-hooks/useAsyncDataCourier';

interface IAntiguedad {
  form: RegistroEntrenadorForm;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  system: SystemClient;
  courier: MessageCourier;
  appContext: AppContext;
  onNextEnable: (valid: boolean) => void;
}

export const Antiguedad = ({ form, onBlurCustomInput, system, courier, appContext, onNextEnable }: IAntiguedad) => {

  const [showAddAnother, setShowAddAnother] = React.useState(false);

  const [antiguedadForm, setAntiguedadForm] = React.useState<RegistroEntrenadorAntiguedadForm>(
    RegistroEntrenadorAntiguedadForm.initialize()
  );

  const forceUpdate = useForceUpdate();
  const [formIsValid, setFormIsValid] = React.useState(false);

  const antiguedadList = useCustomInput(() => form.getAntiguedadEntrenadorListInput(), [form]);

  React.useEffect(() => {
    if (antiguedadList.getValue().length > 0) {
      setShowAddAnother(true);
      onNextEnable(true);
    }
  }, []);



  const clubs = useAsyncDataCourier(
      () =>
        appContext.system.getClubesForDropdown(),
      [],
      appContext.courier
    );

  const addAntiguedad = () => {
    const isAñoDesdeNumber = isNumber(antiguedadForm.getAnioDesdeInput().getValue() as string);
    const isAñoHastaNumber = isNumber(antiguedadForm.getAnioHastaInput().getValue() as string);
    if (!isAñoDesdeNumber || !isAñoHastaNumber) {
      return courier.messageError('Año desde y hasta deben ser números')
    }

    const antiguedad = [...antiguedadList.getValue()];
    antiguedad.push(antiguedadForm.toRegistroEntrenadorAntiguedad());
    antiguedadList.setValue(antiguedad);
    setAntiguedadForm(RegistroEntrenadorAntiguedadForm.initialize());
    onBlurCustomInput(antiguedadList);
    setShowAddAnother(true);
    onNextEnable(true);
  };

 
  const onBlurTitulos = (customInput: CustomInputIfc) => {
    if (antiguedadForm) {
      const isValid = antiguedadForm.getIdInput().getValue()
        ? !antiguedadForm.hasErrors()
        : antiguedadForm?.isValid();
      setFormIsValid(isValid);
      forceUpdate();
      return isValid;
    }
    return false;
  };

  // React.useEffect(() => {
  //   console.log(antiguedadList.getValue());
  // }, [antiguedadList]);

  const onRenderIndexColumn = (item?: any, index?: number, column?: any) => {
    return <span>{index !== undefined ? index + 1 : ''}.</span>;
  };

  const columns = [
    {
      key: 'index',
      name: '',
      fieldName: 'index',
      minWidth: 3,
      maxWidth: 3,
      onRender: onRenderIndexColumn,
    },
    {
      key: 'club',
      name: 'Club',
      fieldName: 'club',
      minWidth: 50,
      maxWidth: 110,
      isMultiline: true,
      onRender: (item: any) => (
        <span>{clubs?.find((c) => c.getId() === item.clubid)?.getNombre() || ''}</span>
      ),
    },
    {
      key: 'anioDesde',
      name: 'Años',
      fieldName: 'anioDesde',
      minWidth: 50,
      maxWidth: 70,
      isMultiline: true,
      onRender: (item: any) => (
        <span>{item.anioDesde + "-" + item.anioHasta}</span>
      ),
    },
    {
      key: 'tipo',
      name: 'Tipo',
      fieldName: 'tipo',
      minWidth: 30,
      maxWidth: 30,
      isMultiline: true,
    },
    {
      key: 'delete',
      name: '',
      fieldName: 'delete',
      minWidth: 10,
      maxWidth: 10,
      onRender: (item: RegistroEntrenadorAntiguedadForm) => (
        <Icon iconName="Trash" onClick={() => handleDelete(item)} styles={iconStyles} />
      ),
    },
  ];

  const handleDelete = (antiguedadDelete: RegistroEntrenadorAntiguedadForm) => {
    antiguedadList.setValue(
      antiguedadList
        .getValue()
        .filter((antiguedad: RegistroEntrenadorAntiguedadForm) => antiguedad !== antiguedadDelete)
    );
    onBlurCustomInput(antiguedadList);
  };

  const iconStyles = {
    root: {
      cursor: 'pointer',
      fontSize: '20px',
    },
  };

  const AntiguedadTipoOptions = [
    { key: 'E', text: 'Entrenador' },
    { key: 'J', text: 'Jugador/a de mayores' },
  ];

  const isNumber = (str: string) => {
    return /^[0-9]+$/.test(str);
  }

  const disableAdd = () => {
    const ret = !antiguedadForm.getClubidInput().getValue() || !antiguedadForm.getCatidInput().getValue() || !checkAñosAreValid() || !antiguedadForm.getTipoInput().getValue() || !antiguedadForm.getAnioDesdeInput().getValue() || !antiguedadForm.getAnioHastaInput().getValue();
    onNextEnable(ret);
    return ret;
  }

  const disableCancel = () =>{
    const tieneDatos = antiguedadForm.getClubidInput().getValue() ||
    antiguedadForm.getCatidInput().getValue() ||
    antiguedadForm.getAnioDesdeInput().getValue() ||
    antiguedadForm.getAnioHastaInput().getValue() ||
    antiguedadForm.getTipoInput().getValue();

    if (tieneDatos) {
      onNextEnable(false);
      return false;
    } else {
       return true;
    }
  }
  
  const cancelAdd = () => {
    setAntiguedadForm(RegistroEntrenadorAntiguedadForm.initialize());
    onNextEnable(true);
  }



  const checkAñosAreValid = () => {
    return parseInt(antiguedadForm.getAnioDesdeInput().getValue() as string) <= parseInt(antiguedadForm.getAnioHastaInput().getValue() as string);
  }



  return (
    <div>
      <div className="ms-Grid" dir="ltr">
        {showAddAnother ? (
          <div className="ms-Grid-row mt-2">
            <div className="ms-Grid-col ms-sm12 form-item">
              <DefaultButton
                onClick={() => setShowAddAnother(false)}
                text="Agregar otro"
                styles={{ root: { width: '100%' } }}
                primary
              />
            </div>
          </div>
        ) : (
          <>
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm6 form-item">
                <ClubSelectorInput
                  appContext={appContext}
                  input={antiguedadForm.getClubidInput()}
                  onBlurCustomInput={onBlurCustomInput}
                  label="Club"
                  clubs={clubs!}
                ></ClubSelectorInput>
              </div>
              <div className="ms-Grid-col ms-sm6 form-item">
                <CategoriaSelectorInput
                  appContext={appContext}
                  input={antiguedadForm.getCatidInput()}
                  onBlurCustomInput={onBlurCustomInput}
                  label="Categoría"
                ></CategoriaSelectorInput>
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm6 form-item">
                <InputField
                  input={antiguedadForm.getAnioDesdeInput()}
                  label={'Año desde'}
                  onBlur={onBlurCustomInput}
                  propsInput={{ type: 'number', inputMode: 'numeric' }}
                />
              </div>
              <div className="ms-Grid-col ms-sm6 form-item">
                <InputField
                  input={antiguedadForm.getAnioHastaInput()}
                  label={'Año hasta'}
                  onBlur={onBlurCustomInput}
                  propsInput={{ type: 'number', inputMode: 'numeric' }}
                />
              </div>
              {antiguedadForm.getAnioDesdeInput().getValue() &&
                antiguedadForm.getAnioHastaInput().getValue() &&
                !checkAñosAreValid() && (
                  <div className="ms-Grid-col ms-sm12 form-item mt-1">
                    <Text className="ms-TextField-errorMessage" styles={{ root: { color: 'red' } }}>
                      Año desde no puede ser mayor que año hasta
                    </Text>
                  </div>
                )}
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12 form-item">
                {/* <ComboBoxInput
                  input={antiguedadForm.getTipoInput()}
                  label={'Tipo'}
                  onBlur={onBlurCustomInput}
                  options={AntiguedadTipoOptions}
                /> */}
                <ChoiceGroup
                  selectedKey={antiguedadForm.getTipoInput().getValue()}
                  options={AntiguedadTipoOptions.map((option) => ({
                    key: option.key,
                    text: option.text,
                  }))}
                  onChange={(e: any, option: any) => {
                    antiguedadForm.getTipoInput().setValue(option?.key);
                    onBlurCustomInput(antiguedadForm.getTipoInput());
                  }}
                  styles={{ flexContainer: { display: 'flex', flexDirection: 'row', gap: '20px' } }}
                />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12 form-item">
                <DefaultButton
                  disabled={disableAdd()}
                  onClick={addAntiguedad}
                  text="Agregar"
                  styles={{ root: { width: '100%' } }}
                  primary
                />
                 {<DefaultButton 
                  disabled={disableCancel()} 
                  onClick={cancelAdd} 
                  text="Cancelar"
                  styles={{ root: { width: '100%', marginTop: 8} }} />}
              </div>
            </div>
          </>
        )}

        {/* {antiguedadList.getValue().map((titulo: RegistroEntrenadorTitulo, index: number) => ( */}
        <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm12 form-item">
            <DetailsList
              items={antiguedadList.getValue()}
              columns={columns}
              layoutMode={DetailsListLayoutMode.fixedColumns}
              selectionMode={SelectionMode.none}
            />
          </div>
        </div>
        {/* ))} */}
      </div>
    </div>
  );
};
